import { orpc } from "@/lib/orpc";

/** One order for the admin: the detail page's query, which its actions update. */
export const orderQuery = (orderId: string) => orpc.order.get.queryOptions({ input: { orderId } });
